<template>
  <div class="scroll-container" ref="scrollContainer">
    <div class="scroll-content">
      <!-- 渲染数据项 -->
      <!-- <div v-for="item in items" :key="item.id" class="item">{{ item.id }}</div> -->
      <div
        class="item brand-item"
        v-for="(v2, i2) in items"
        :key="i2"
      >
        <div @click="() => toDetail(categoryId, v2)">
          <img :src="v2.brandLogo || goodsDefault" />
          <div class="brand-title">
            {{ v2.name }}
          </div>
        </div>
      </div>
      <!-- 加载提示 -->
      <div v-if="loading" class="loading" v-loading="loading"></div>
      <div v-if="!hasMore && brands.length > 10" class="no-more">
        没有更多了
      </div>
      <div v-if="brands.length === 0">暂无数据</div>
      <!-- 用于监听的占位元素 -->
      <div ref="observerTarget" class="observer-target"></div>
    </div>
  </div>
</template>

<script>
import goodsDefault from '@/assets/img/goods_default.png'
export default {
  name: 'HorizontalScrollLoadMore',
  props: {
    brands: {
      type: Array,
      default: () => []
    },
    categoryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      goodsDefault,
      items: [], // 初始数据
      loading: false, // 加载状态
      observer: null, // IntersectionObserver 实例
      page: 1, // 当前页码
      limit: 20, // 每页加载的数据数量
      hasMore: true // 是否还有更多数据
    }
  },
  mounted () {
    this.items = [...this.brands]
    if (this.brands.length < this.limit) {
      this.hasMore = false
    }
    // 创建 IntersectionObserver 实例
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.loading) {
          // 当目标元素进入可视区域且不在加载状态时，触发加载更多
          this.loadMore()
        }
      })
    })
    // 监听目标元素
    this.observer.observe(this.$refs.observerTarget)
  },
  beforeDestroy () {
    // 组件销毁前停止监听
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    toDetail (categoryId, v) {
      let query = {
        foregroundCategoryId: categoryId,
        brandIdList: v && v.brandId,
        seriesIdList: '',
        attributeValueIdList: '',
        salesDesc: false,
        priceDesc: false,
        popularityDesc: false,
        category: true
      }
      let queryStr = Object.keys(query).map(v => `${v}=${query[v]}`).join('&')
      window.open('/premiumGoodCategoryList?' + queryStr)
      // this.$router.push({
      //   path: '/premiumGoodCategoryList',
      //   query: {
      //     foregroundCategoryId: categoryId,
      //     brandIdList: v && v.brandId,
      //     seriesIdList: '',
      //     attributeValueIdList: '',
      //     salesDesc: false,
      //     priceDesc: false,
      //     popularityDesc: false,
      //     category: true
      //   }
      // })
    },
    loadMore () {
      if (this.loading || !this.hasMore) {
        return
      }
      this.loading = true
      this.page++
      // 模拟异步加载数据
      const obj = {
        categoryId: this.categoryId,
        limit: this.limit,
        page: this.page
      }
      this.$http
        .post('/front/cross/commodity-user/boutique/brands', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.loading = false
            this.items = [...this.items, ...res.data.dataList]
            this.hasMore = res.data.hasMore
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-container {
  width: 100%;
  max-height: 286px;
  overflow-y: auto;
  white-space: wrap;
}

.scroll-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.item {
  display: inline-block;
}

.loading {
  width: 100%;
}

.no-more {
  width: 100%;
  text-align: center;
}

.observer-target {
  padding: 0 1px;
  width: 100%;
}

.brand-item {
  width: 25%;
  cursor: pointer;
  img {
    display: block;
    margin: 0 auto;
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 12px;
  }
}

.brand-title {
  display: block;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 19px;
  padding: 4px 0 0;
  margin-bottom: 20px;
}
</style>
